import { useEffect, useState } from "react";
import {
  CurrentReservationResponse,
  CurrentReservationType,
  getCurrentReservationById,
  SellerReservationDto,
} from "../../../api/reservation";
import { PaginationWrapper, TableProps } from "../../../component/CommonTable";
import {
  CurrentReservationPopupContainer,
  CurrentReservationPopupContentBodyWrapper,
  CurrentReservationPopupContentHeaderWrapper,
  CurrentReservationPopupContentWrapper,
  ImageWrapper,
  InputDataWrapper,
  Title,
  HeaderActionsWrapper,
  ResContentWrapper,
  MemberTableWrapper,
  TableHeader,
  TableContentWrapper,
  TableContent,
  ColumnItem,
  HeaderItem,
} from "../styles/currentReservation";
import { StructuresResponse } from "../../tournament/hook/useEditTournament";
import Pagination from "../../../component/Pagination";

const CurrentReservation = (props: {
  currentReservation: SellerReservationDto;
  setIsCurrentOpen: any;
}) => {
  const reservation = props.currentReservation;
  const id = props.currentReservation.id;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const setIsCurrentOpen = props.setIsCurrentOpen;
  const [list, setList] = useState<CurrentReservationResponse[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 7;

  const getCurrentReservation = async () => {
    if (!id) return;
    const res = await getCurrentReservationById(id);
    setList(
      res.map((reservation: CurrentReservationResponse, index: number) => {
        reservation.index = res.length - index;
        return reservation;
      })
    );
  };

  useEffect(() => {
    getCurrentReservation();
  }, []);

  useEffect(() => {
    const filteredListLength = filteredList.length;
    setTotalPages(Math.ceil(filteredListLength / itemsPerPage));
    setCurrentPage(1);
  }, [list, searchTerm]);

  const columns: TableProps<CurrentReservationResponse>["columns"] = [
    {
      key: "index",
      header: "NO",
      render: (item) => item.index,
      weight: 0.5,
    },
    {
      key: "nickName",
      header: "닉네임",
      render: (item) => item.nickName,
      weight: 3,
      style: "date",
    },
    {
      key: "createdAt",
      header: "시간",
      render: (item) =>
        reservationTime(
          new Date(item.createdAt),
          new Date(props.currentReservation.tournamentStart),
          props.currentReservation.tournamentStructure
        ),
      weight: 1.5,
    },
    {
      key: "phoneNumber",
      header: "전화번호",
      render: (item) => item.phoneNumber,
      weight: 1.5,
    },
    {
      key: "root",
      header: "예약 경로",
      render: (item) => {
        return item.root === "WEB" ? "웹" : "앱";
      },
      weight: 0.7,
    },
    {
      key: "reservationType",
      header: "예약 방식",
      render: (item) => {
        return item.reservationType === CurrentReservationType.SEED ||
          reservation.isSeedPay
          ? "래빗 예약"
          : item.reservationType === CurrentReservationType.POINT
          ? "이용권 예약"
          : "일반 예약";
      },
      weight: 1,
    },
  ];

  const reservationTime = (
    createdAt: Date,
    startTime: Date,
    structures: StructuresResponse[]
  ) => {
    if (structures.length < 1) return "알수없음";
    const time = createdAt.getTime() - startTime.getTime();
    if (time < 0) {
      return "사전 예약";
    }

    const yyyy = createdAt.getFullYear();
    const MM = ("0" + (1 + createdAt.getMonth())).slice(-2);
    const dd = ("0" + createdAt.getDate()).slice(-2);

    const hh = ("0" + createdAt.getHours()).slice(-2);
    const mm = ("0" + createdAt.getMinutes()).slice(-2);

    return `${yyyy}.${MM}.${dd} / ${hh}:${mm}`;
  };

  const filteredList = list.filter((item) =>
    item.nickName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <CurrentReservationPopupContainer>
      <CurrentReservationPopupContentWrapper>
        <CurrentReservationPopupContentHeaderWrapper>
          <span>예약 현황 ({filteredList.length.toLocaleString()}명)</span>
          <HeaderActionsWrapper>
            <img
              src="/image-web/tournament/close.svg"
              onClick={() => {
                setIsCurrentOpen(false);
              }}
              alt="close"
            />
          </HeaderActionsWrapper>
        </CurrentReservationPopupContentHeaderWrapper>
        <CurrentReservationPopupContentBodyWrapper>
          <ImageWrapper src={props.currentReservation.imageUrl}></ImageWrapper>
          <InputDataWrapper>
            <Title>{props.currentReservation.title}</Title>
            <ResContentWrapper>
              <HeaderActionsWrapper>
                <div className="searchBox">
                  <input
                    type="text"
                    placeholder="닉네임 검색"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <div className="searchIcon" onClick={() => {}}>
                    <img
                      src="/image-web/tournament/search.png"
                      alt="검색 아이콘"
                    />
                  </div>
                </div>
              </HeaderActionsWrapper>
              <MemberTableWrapper>
                <TableHeader>
                  {columns.map((column, index) => (
                    <HeaderItem
                      className={`i${index}`}
                      weight={column.weight}
                      key={index}
                    >
                      {column.header}
                    </HeaderItem>
                  ))}
                </TableHeader>
                <TableContentWrapper>
                  {paginatedList.map((item, rowIndex) => (
                    <TableContent key={rowIndex}>
                      {columns.map((column, colIndex) => (
                        <ColumnItem
                          className={`i${colIndex}`}
                          weight={column.weight}
                          key={colIndex}
                        >
                          <span>
                            {column.key === "actions"
                              ? null
                              : column.key === "check"
                              ? null
                              : column.render
                              ? column.render(item)
                              : column.key === "index"
                              ? rowIndex + 1
                              : String(item[column.key])}
                          </span>
                        </ColumnItem>
                      ))}
                    </TableContent>
                  ))}
                </TableContentWrapper>
                {totalPages > 1 && (
                  <PaginationWrapper>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                  </PaginationWrapper>
                )}
              </MemberTableWrapper>
            </ResContentWrapper>
          </InputDataWrapper>
        </CurrentReservationPopupContentBodyWrapper>
      </CurrentReservationPopupContentWrapper>
    </CurrentReservationPopupContainer>
  );
};

export default CurrentReservation;
